$(document).ready(function() {
  $('.announcement-bar-slick').slick({
    adaptiveHeight: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    buttons: false,
    centerMode: true,
    cssEase: 'linear',
    dots: false,
    draggable: false,
    speed: 10000,
    slidesToShow: 1,
    variableWidth: true
  });

  // temp fix to display rushify and shipping bar plugin on iOS
  if ($('#shopify-section-cart-template').length > 0) {
    setTimeout(function() {
      $('body').click();
    }, 100);
  }

  // remove height of the additional checkout buttons
  if ($('.additional-checkout-buttons').length > 0) {
    var cartInterval = setInterval(function() {
      var checkoutList = $('.additional-checkout-buttons .shopify-cleanslate').eq(1).find('ul li');
      if (checkoutList.length > 0) {
        checkoutList.attr('style', 'height: auto !important;');
        clearInterval(cartInterval);
      }
    }, 250);
    setTimeout(function() { clearInterval(cartInterval); }, 10000);
  }

  // add cart item count on pagefly nap earring page
  $('.btn-add-nap-earring').on('click', function () {
    var $cartLinkCount = $('.cart-link__count');
    var cartItemCount = $cartLinkCount.text();
    var $btn = $(this);
    var cartItemCountInterval = setInterval(function() {
      if ($btn.text() == 'Thank you!') {
        if (cartItemCount && !isNaN(cartItemCount)) {
          $cartLinkCount.text(Number(cartItemCount) + 1);
        } else {
          $('.cart-link__icon').append('<span class="cart-link__count">1</span>');
        }
        
        clearInterval(cartItemCountInterval);
      }
    }, 50);
  });

  // scroll up when klaviyo form was submitted
  setTimeout(function() {
    $('div.klaviyo-form button:contains("Submit")').on('click', function() {
      console.log('submit');
      setTimeout(function() { $(window).scrollTop(0); }, 750);
    });
  }, 1000);
});